export const initialAppState = {
    appSettings: undefined,
};
